export const scrollChatToBottom = (scrollArea) => {
  if (!scrollArea) return false;

  const question = scrollArea.querySelector?.('[data-clarification-question]');
  if (question) {
    const questionTop = scrollArea.scrollTop + question.getBoundingClientRect().top -
      scrollArea.getBoundingClientRect().top;
    scrollArea.scrollTop = Math.min(
      scrollArea.scrollHeight - scrollArea.clientHeight,
      Math.max(0, questionTop - 8)
    );
  } else {
    scrollArea.scrollTop = scrollArea.scrollHeight;
  }
  return true;
};

export const scheduleChatScrollToBottom = ({
  getScrollArea,
  requestFrame,
  cancelFrame,
}) => {
  let settledFrameId;
  const initialFrameId = requestFrame(() => {
    scrollChatToBottom(getScrollArea());
    settledFrameId = requestFrame(() => {
      scrollChatToBottom(getScrollArea());
    });
  });

  return () => {
    cancelFrame(initialFrameId);
    if (settledFrameId !== undefined) {
      cancelFrame(settledFrameId);
    }
  };
};

export const observeChatResize = ({
  scrollArea,
  ResizeObserverClass,
}) => {
  if (!scrollArea || !ResizeObserverClass) return () => {};

  const observer = new ResizeObserverClass(() => {
    scrollChatToBottom(scrollArea);
  });
  observer.observe(scrollArea);

  if (scrollArea.firstElementChild) {
    observer.observe(scrollArea.firstElementChild);
  }

  return () => observer.disconnect();
};
